import { shortAddress } from "@bentolabs/kit/web3";
import { useAccount, useDisconnect } from "wagmi";

import Exit from "shared/assets/exit.svg?react";
import { Avatar } from "shared/ui/avatar";

export const Header = () => {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();
  return (
    <header className="flex items-center justify-between bg-white/5 pl-5 text-sm">
      {address && (
        <div className="flex items-center gap-x-3.5">
          <Avatar name={address} /> {shortAddress(address, 5, 5)}
        </div>
      )}

      <button
        onClick={() => disconnect()}
        className="cursor-pointer px-5 py-3.5 outline-hidden transition-colors hover:brightness-125"
      >
        <Exit className="text-nobel" />
      </button>
    </header>
  );
};
